import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  FulfilledBy,
  FulfillmentGroupData,
  getFulfillmentGroupValue,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExplicitInsuredParcelsValue } from "../fulfillment-group-insurance";

type InsuranceStatus = "fully-insured" | "partially-insured" | "none";

function getInsuranceStatusText(status: InsuranceStatus): string {
  switch (status) {
    case "fully-insured":
      return "Fully insured";
    case "partially-insured":
      return "Partially insured";
    case "none":
      return "";
  }
}

function getInsuranceStatus(row: FulfillmentGroupData): InsuranceStatus {
  if (row.fulfilledBy !== FulfilledBy.REDO) {
    return "none";
  }

  const totalInsuredAmount = getExplicitInsuredParcelsValue(row);
  const totalGroupValue = getFulfillmentGroupValue(row);

  if (totalInsuredAmount >= totalGroupValue) {
    return "fully-insured";
  }

  return "partially-insured";
}

export const ShippingInsuranceCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipping insurance",
    cell: (row) => {
      return getInsuranceStatusText(getInsuranceStatus(row));
    },
  };
